export const MOBILE_AUTH_TOKEN_STORAGE_KEY = 'MOBILE_AUTH_TOKEN_STORAGE_KEY';
